import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetOrderDocumentTypes(orderTypeId, orderId) {
  const response = await $.soap({
    body: {
      GetOrderDocumentTypes: {
        $xmlns: 'http://dla.mil/ems/bpm/document',
        OrderFormTypeID: orderTypeId,
        OrderID: orderId
      }
    },
    blueprintArrays: ['GetOrderDocumentTypesResponse.LU_DocumentObjectMapping'],
    blueprint: {
      documentTypes: [
        '$..LU_DocumentObjectMapping',
        {
          objectCode: '$.ObjectCode',
          objectDescription: '$.ObjectDescription',
          orderFormTypeId: '$.OrderFormTypeID',
          orderFormTypeCode: '$.OrderFormTypeCode',
          orderFormTypeName: '$.OrderFormTypeName',
          isRequired: '$..IsRequired',
          documentTypeDescription: '$.DocumentTypeDescription',
          documentTypeId: '$.DocumentTypeID',
          documentTypeCode: '$.DocumentTypeCode',
          defaultFileName: '$.DefaultFileName',
          attachmentId: '$.GUID',
          isFunding: '$.IsFunding'
        }
      ]
    }
  });

  cleanUpResponse(response);
  return response.documentTypes;
}
